/**
 * ヘッダー文字列の表記ゆれ（BOM・前後空白・引用符・全角括弧・大文字小文字）を吸収する。
 */
function normalizeCsvHeader(header: string): string {
  return header
    .replace(/^﻿/, '')
    .replace(/[（]/g, '(')
    .replace(/[）]/g, ')')
    .replace(/[\s　"']/g, '')
    .toLowerCase()
}

/**
 * CSVヘッダーを正規キーに変換する関数を作る。未知のヘッダーは正規化した文字列をそのまま返す。
 * 返す関数は Papa Parse の `transformHeader` にそのまま渡せる（冪等）。
 */
export function createCsvHeaderResolver<F extends string>(
  fields: readonly F[],
  aliases: Record<F, readonly string[]>,
): (header: string) => string {
  const headerToField: ReadonlyMap<string, F> = new Map(
    fields.flatMap((field) =>
      // 正規キー自身もエイリアスに含めることで、二重適用しても結果が変わらないようにする
      // （Papa Parse は区切り文字の自動判定時に transformHeader を2回呼ぶ）
      [field, ...aliases[field]].map((alias) => [normalizeCsvHeader(alias), field] as [string, F]),
    ),
  )

  return (header) => {
    const normalized = normalizeCsvHeader(header)
    return headerToField.get(normalized) ?? normalized
  }
}
